import React from "react";
import MarketplaceBase from "./marketplace/MarketplaceBase";

// Standalone Intercity marketplace section (separate from legacy orders).
export default function IntercityPanelScreen(props) {
  return <MarketplaceBase serviceType="intercity" title="Şehirlerarası Taşıma" history={props.history} />;
}
